exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "", "", {"version":3,"sources":[],"names":[],"mappings":"","file":"spacing.css","sourceRoot":""}]);

// exports
exports.locals = {
	"btnPadding": "10px 22px",
	"btnSmallPadding": "4px 20px"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader??ref--0-1!./node_modules/postcss-loader/lib!./src/styles/spacing.css
// module id = 12
// module chunks = 3